import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        & > div {
            width: 100%;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
                null,
                null,
                null,
            ])}
    `,
};

myListsDetailsOptionsStyles.pagination = {
    cssOverrides: {
        pagination: css`
            nav {
                padding-right: 12px;
            }
            @media print {
                display: none;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        justify-content: end;
                        nav {
                            padding-right: 40px;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
